export default __webpack_public_path__ + "static/media/MP5_5.596ec615.png";